























import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class CodeEditor extends Vue {
  @Prop() code: string;
  codeLines = [""];
  lines = 0;

  created() {
    this.codeLines = this.formatCode().split("\n");
    this.lines = this.codeLines.length;
    this.$emit("number-of-lines", this.lines);
  }

  formatCode() {
    return JSON.stringify(JSON.parse(this.code), null, 2);
  }
}
